import React from 'react';
import { SpinLoading } from 'antd-mobile';


function Spin({ loading, children }) {
  return (
    <div className="loading-overlay-container">
      {children}
      {loading && (
        <div className="loading-overlay">
          <SpinLoading color="primary" size="large" />
        </div>
      )}
    </div>
  );
}

export default Spin;
